module.exports = __webpack_public_path__ + "img/banner_index_m.1fe77bcd.jpg";